import { z } from "zod";

// Payload for POST /admin/jobs/trigger — fires an immediate run of a registered recurring job by id.
// Kept minimal + JSON-Schema-representable (no transform/refine) so it round-trips Zod → JSON Schema → C#.
export const triggerJobRequestSchema = z.object({
  recurring_job_id: z.string().min(1, "Recurring job id is required"),
});
